export enum LittDirection {
    LONG = "LONG",
    SHORT = "SHORT"
}
